
import { FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { ofArray, singleton, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getProcedureForm } from "../../Requests/Procedure.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Storage_$reflection } from "../../Shared/Storage.js";
import { list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { createProcedureResultsPdf } from "../../Requests/PDF.js";
import { onBlobReceived, getBlob } from "../../CommunicationV2.js";

export function init(procedureId) {
    return [new State(procedureId, new RequestedValue$1(0, []), empty(), FormState_get_empty()), Cmd_batch(ofArray([getProcedureForm(procedureId, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1]))), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item_2) => (new Msg(1, [Item_2])), (Item_3) => (new Msg(2, [Item_3])))]))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.ProcedureId, state.ProcedureForm, msg.fields[0], state.FormState), Cmd_none()];
        case 2:
            return [new State(state.ProcedureId, state.ProcedureForm, state.Storages, FormState_get_empty()), Cmd_none()];
        case 3:
            return [new State(state.ProcedureId, state.ProcedureForm, state.Storages, FormState__startLoading(state.FormState)), createProcedureResultsPdf(state.ProcedureId, (tupledArg) => (new Msg(4, [tupledArg[0], tupledArg[1]])), (Item_2) => (new Msg(2, [Item_2])))];
        case 4:
            return [state, getBlob(msg.fields[0], msg.fields[1], (tupledArg_1) => (new Msg(5, [tupledArg_1[0], tupledArg_1[1]])), (Item_5) => (new Msg(2, [Item_5])))];
        case 5: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [new State(state.ProcedureId, state.ProcedureForm, state.Storages, FormState_get_empty()), Cmd_none()];
        }
        default:
            return [new State(state.ProcedureId, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.FormState), Cmd_none()];
    }
}

